import React from "react";

export default function Button(props) {
  return (
    <button
      ref={props.editorRef}
      style={{
        position: "relative",
        visibility: props.block.hidden ? "hidden" : "unset",
        backgroundColor: props.block.props.backgroundColor,
        flexGrow: props.block.props.flexGrow,
        boxShadow: props.block.props.boxShadow,
        ...props.block.props.textstyle,
        ...props.block.props.size,
        ...props.block.props.border,
        ...props.block.props.spacing,
      }}
    >
      {props.block.props.value}
    </button>
  );
}
